/**
 * Navigasyon sırasında "from" state'ini otomatik geçirir.
 * Hedef sayfadaki Geri Dön butonu bu sayfaya dönebilir.
 * @param {Function} navigate - useNavigate()
 * @param {string} path - Gidilecek path
 * @param {object} location - useLocation()
 * @param {object} options - navigate'e geçilecek ek seçenekler (state, replace vb.)
 */
export function navigateWithFrom(navigate, path, location, options = {}) {
  const from = location?.pathname + (location?.search || '');
  navigate(path, {
    ...options,
    state: {
      ...(options.state || {}),
      from,
    },
  });
}
